export default __webpack_public_path__ + "img/15.asset.7fd5b733.jpeg";